import React, { useState, useRef } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
// import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MyEditor from "../common/Editor";
// import MultipleFileDropzone from "../PageForum/form/fileUploader";
import auth from "./../../services/authservice";

const TopicForm = ({ onSubmit, topicCategory }) => {
  const user = auth.getProfile();
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [formData, setFormData] = useState({
    //user: topicCategory?.user?._id,
    user: user._id,
    title: "",
    catId: topicCategory?._id,
    narrative: "",
    tags: "",
    views: 1,
    attachments: [],
    status: "active",
  });

  const [errors, setErrors] = useState({
    title: "",
    catId: "",
    narrative: "",
    tags: "",
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "file") {
      const files = Array.from(e.target.files);
      setFormData((prevData) => ({
        ...prevData,
        [name]: [...prevData[name], ...files],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const FormDataWithAttachments = {
      ...formData,
      attachments: attachments,
    };
    console.log(FormDataWithAttachments);
    onSubmit(FormDataWithAttachments);
  };

  return (
    <Box p={2} m={2}>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          name="title"
          label="Title"
          variant="outlined"
          value={formData.title || ""}
          onChange={handleChange}
          margin="normal"
        />
        {errors.title && <Typography color="error">{errors.title}</Typography>}

        <MyEditor 
          initialContent={formData.narrative} 
          onChangeHandler={(value) => setFormData({ ...formData, narrative: value })} 
        />

        <TextField
          fullWidth
          name="tags"
          label="Tags"
          variant="outlined"
          value={formData.tags || ""}
          onChange={handleChange}
          margin="normal"
        />

        <Box mt={2} mb={2}>
          {formData.attachments.length > 0 && (
            <div>
              <Typography variant="subtitle1">Uploaded Files:</Typography>
              <ul>
                {formData.attachments.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}
        </Box>
        <Button type="submit" variant="contained" color="primary">
          Add Topic
        </Button>
      </form>
    </Box>
  );
};

export default TopicForm;
